import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { getTreatmentInstances, cancelTreatmentInstance } from '../../../../actions/entities';
import TreatmentInstanceDialogCancellation from '../../../../components/DailyPlanning/TreatmentInstanceDialog/Cancellation/TreatmentInstanceDialogCancellation';

const mapDispatchToProps = dispatch => ({
  navigate: url => dispatch(push(url)),
  cancel: async (treatmentId, treatmentInstanceId, reasonId, riskAssesment, dateAt, timeSlots) => {
    await dispatch(
      cancelTreatmentInstance(treatmentId, treatmentInstanceId, reasonId, riskAssesment, dateAt, timeSlots),
    );
    dispatch(getTreatmentInstances(true));
  },
});

const TreatmentInstanceDialogCancellationContainer = connect(
  null,
  mapDispatchToProps,
)(TreatmentInstanceDialogCancellation);

export default TreatmentInstanceDialogCancellationContainer;
